// Frontend screen policy: update these helpers and the roleLanding/App parity
// tests when adding a role or screen. Backend/action authority remains separate.
export function normalizedUserRoles(user) {
  if (Array.isArray(user?.roles)) return user.roles;
  return user?.role ? [user.role] : [];
}

export function defaultAuthenticatedPath(user, { offline = false } = {}) {
  const roles = normalizedUserRoles(user);
  if (roles.includes('admin')) return offline ? '/orders' : '/';
  if (roles.includes('designer')) return '/design';
  if (roles.includes('driver')) return offline ? '/settings' : '/my-runs';
  // Preserve the legacy fallback for unsupported account shapes. New roles
  // need an explicit landing decision rather than inheriting new permissions.
  return '/';
}

export function canAccessAuthenticatedPath(user, path, { desktop = false } = {}) {
  const roles = normalizedUserRoles(user);
  const isAdmin = roles.includes('admin');
  const isDesigner = roles.includes('designer');
  const isDriver = roles.includes('driver');

  if (path === '/settings') return true;
  if (path === '/design') return isAdmin || isDesigner;
  if (path === '/my-runs') return isDriver;
  if (path === '/reconciliation') return desktop && isAdmin;
  if (['/', '/incoming', '/upload', '/orders', '/dispatch'].includes(path)) {
    return isAdmin;
  }
  return false;
}

// Availability is not role permission. Keep unavailable tabs visible/disabled,
// while direct entry must satisfy BOTH this check and the role check above.
// canCaptureOffline is supplied by the existing device/role eligibility owner.
export function isAuthenticatedPathAvailable(path, {
  offline = false,
  canCaptureOffline = false,
} = {}) {
  if (!offline) return true;
  if (path === '/upload') return canCaptureOffline;
  return ['/orders', '/design', '/dispatch', '/settings'].includes(path);
}

export function isAuthenticatedPathVisible(user, path, context = {}) {
  return canAccessAuthenticatedPath(user, path, context)
    // Preserve Review's existing hidden state on non-primary/unknown devices.
    && (path !== '/reconciliation' || Boolean(context.canCaptureOffline));
}

export function canOpenAuthenticatedPath(user, path, context = {}) {
  return isAuthenticatedPathVisible(user, path, context)
    && isAuthenticatedPathAvailable(path, context);
}
